<mat-form-field>
  <mat-label>{{ label() }}</mat-label>

  <input
    placeholder="Type at least 3 characters"
    matInput
    #input
    [formControl]="control"
    [matAutocomplete]="auto"
    (focus)="onFocus()" />

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCustomer" (optionSelected)="isLoading = false">
    <div matAutocompleteOrigin>
      @if (isLoading) {
        <mat-option disabled>
          <mat-spinner diameter="20"></mat-spinner>
        </mat-option>
      }
    </div>
    @for (option of options; track option.number) {
      <mat-option [value]="option">
        <strong>{{ option.name }}</strong> ({{ option.number }})
      </mat-option>
    } @empty {
      @if (input.value.length > 2 && !isLoading) {
        <mat-option (click)="createParty()"
          >No results found, add a new party
          <mat-icon>add</mat-icon>
        </mat-option>
      }
    }
  </mat-autocomplete>
  @if (control.hasError('required') && control.touched) {
    <mat-error>Party is required</mat-error>
  }
</mat-form-field>
